import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import BannerImage from '../assets/images/landing-payu/BANNER PAGO ESTRELLA.svg';
import { PAYMENT_STATUS_PSE } from '../constants/payment/paymentStatusPSE';
// import { PAYMENT_METHODS } from '../constants/payment/paymentMethods';
import Button from '../components/DynamicForm/Button';
import { formatCurrency, formatDateHour, formatNumber } from '../utils/format';
import ConsultGeneral from '../services/consult/consult-general';
import { useDialog } from '../context/dialog-context';
import { DIALOG } from '../constants/dialog/dialog';
import { useNavigate } from 'react-router-dom';

const LandingPayu = () => {
  const dialog = useDialog();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const creditId = searchParams.get('creditId');
  const ticketId = searchParams.get('ticketId');
  const functions = searchParams.get('functions');
  const trazabilityCode = searchParams.get('trazabilityCode');
  
  let resul = searchParams.get('trazabilityCode');

  const [transactionState, setTransactionState] = useState('-');
  const [createTime, setCreateTime] = useState('-');
  const [transactionValue, setTransactionValue] = useState('-');
  const [referenceNumber1, setReferenceNumber1] = useState('-');
  const [referenceNumber2, setReferenceNumber2] = useState('-');
  const [referenceNumber3, setReferenceNumber3] = useState('-');
  const [email, setEmail] = useState('-');
  const [financialInstitutionCode, setFinancialInstitutionCode] = useState('-');
  const [paymentDescription, setPaymentDescription] = useState('-');
  const [authorizationID, setAuthorizationID] = useState('-');
  const [trazabilityCodeFinish, setTrazabilityCodeFinish] = useState('-');
  const [ticketIdPse, setTicketIdPse] = useState(searchParams.get('ticketId'));
  // const [infoTransactionPayment, setInfoTransactionPayment] = useState('-');
  const [fetchedConsultBankList, setFetchedConsultBankList] = useState();

  const showDialogProceso = (message, returnIndex = false) => {
    dialog.custom(
      <>
        <div className="space-y-4 text-center">
          <p>
        {message}

          </p>
        </div>
        <div className="flex w-full justify-center space-x-2 mt-5">
          <Button
            onClick={async () => {
              if (returnIndex) {
                dialog.close();
                navigate('/');
              } else {
                dialog.close();
              }
            }}
            customColor="bg-custom-red"
          >
            {'Cerrar'}
          </Button>
        </div>
      </>,
    );
  }; 
  
  const getDataResumenTransaction = async (ticketId, creditId, functions, trazabilityCode = null) => {
    const body = {
      creditId: creditId,
      ticketId: ticketId,
      functions: functions,
      trazabilityCode: trazabilityCode,
      rol: 'getTransactionInformation',
    };
    try {
      resul = await ConsultGeneral.postConsultPSE(body);
      
    } catch (error) {
      if (error?.response?.data?.error?.description.includes('trazabilityCode')) {
        showDialogProceso(error?.response?.data?.error?.description);
      } else {
        dialog.info(DIALOG.N11, {
          devInfo: error.message || error.code || error.type,
        });
      }
    }
    if (resul?.message?.includes('FAILED_FINISH')) {
      showDialogProceso(PAYMENT_STATUS_PSE[resul.message]?.label, true);
    } else if (resul?.length > 0) {
        const infoData = JSON.parse(resul[0]?.info_transaction_payment);
  
        setTransactionState(resul[0].transactionState);
        setCreateTime(resul[0].createtime);
        setTransactionValue(infoData.transactionValue);
        setReferenceNumber1(infoData.referenceNumber1);
        setReferenceNumber2(infoData.referenceNumber2);
        setReferenceNumber3(infoData.referenceNumber3);
        setEmail(infoData.email);
        setFinancialInstitutionCode(infoData.financialInstitutionCode);
        setPaymentDescription(infoData.paymentDescription);
        setTrazabilityCodeFinish(infoData.trazabilityCode);
        setTicketIdPse(resul[0].ticketIdPse);
        if (resul[0].transactionState === 'OK') {
          setAuthorizationID(infoData.authorizationID);
        }
        // setInfoTransactionPayment(infoData);
      
    } else {
        setTransactionState(resul.transactionState);
        setCreateTime(resul.soliciteDate);
        setTransactionValue(resul.transactionValue);
        setReferenceNumber1(resul.referenceNumber1);
        setReferenceNumber2(resul.referenceNumber2);
        setReferenceNumber3(resul.referenceNumber3);
        setEmail(resul.email);
        setFinancialInstitutionCode(resul.financialInstitutionCode);
        setTicketIdPse(resul.ticketIdPse? resul.ticketIdPse : resul.ticketId);
        setTrazabilityCodeFinish(resul.trazabilityCode);

        setPaymentDescription(resul.paymentDescription);
      }
  };

  useEffect(() => {
    let intervalId;
  
    const checkData = async () => {
      if (ticketId && creditId && functions) {
        await getDataResumenTransaction(ticketId, creditId, functions, trazabilityCode);
      }
    };
  
    // Ejecuta la función inicialmente
    if (transactionState === '-') {
      checkData();
    }
  
    // Configura el intervalo si el estado es "PENDING"
    if (transactionState === 'PENDING') {
      intervalId = setInterval(checkData, 180000); // 60 segundos
    }
  
    // Limpia el intervalo cuando el componente se desmonta o el estado cambia
    return () => clearInterval(intervalId);
  }, [ticketId, creditId, functions, transactionState]); // Dependencias incluyen transactionState
  
  useEffect(() => {
    const fetchCreditRenovation = async () => {
      const body = {
        rol: 'getBankList',
      };
      const resul = await ConsultGeneral.postConsultPSE(body);
      const formattedBankList = resul
      .filter(element => financialInstitutionCode === element.financialInstitutionCode)
      .map(element => ({
        value: element.financialInstitutionCode,
        label: element.financialInstitutionName
      }));
      setFetchedConsultBankList(formattedBankList);
    };
    fetchCreditRenovation();
  }, [financialInstitutionCode]);
  
  useEffect(() => {
    const fetchCreditRenovation = async () => {
      const body = {
        creditId,
        trazabilityCode: trazabilityCode ? trazabilityCode : trazabilityCodeFinish,
        ticketId,
        entityAuthorizationId:authorizationID,
        rol: 'finalizeTransactionPayment',
      };
      await ConsultGeneral.postConsultPSE(body);
      // showDialogProceso(PAYMENT_STATUS_PSE['OK']?.label);
    };
    if (transactionState === 'OK') {
      fetchCreditRenovation();
      
    }
  }, [transactionState]);
  return (
    <div className="flex flex-col items-center">
      <h2 className="pb-6 text-center text-xl font-bold text-custom-green">
        Estado del pago
      </h2>
      <p className="pb-4 text-center text-lg">
        <b>Resumen general</b>
      </p>
      <div className="space-y-5">
        <div className="flex flex-1 items-center justify-center">
          <img src={BannerImage} alt="banner, realizaste un pago estrella" />
        </div>
        <p>
          <b>
            Estado: {PAYMENT_STATUS_PSE[transactionState]?.label}
          </b>
        </p>
        <p>
          <b>
            Banco: { fetchedConsultBankList && fetchedConsultBankList[0]?.label }
          </b>
        </p>
        <p>
          <b>CUS:</b> {trazabilityCode ? trazabilityCode : trazabilityCodeFinish}
        </p>
        <p>
          <b>
            Id de transacción: { ticketIdPse }
          </b>
        </p>
        <p>
          <b>Fecha:</b> {formatDateHour(createTime, { showHour: true, })}
        </p>
        <p>
          <b>Valor:</b> {formatCurrency(transactionValue)}
        </p>

        <p>
          <b>Descripcion:</b> {paymentDescription}
        </p>
        <p>
          <b>Nombre:</b> {referenceNumber1}
        </p>

        <p>
          <b>Número de documento:</b> {formatNumber(referenceNumber2)}
        </p>

        <p>
          <b>Celular:</b> {referenceNumber3}
        </p>

        <p>
          <b>Email:</b> {email}
        </p>  
        
        <p>
          <b>RECUERDA: Los pagos realizados se verán reflejados en el perfil de usuario Estrella, hasta en 2 días hábiles.</b>
        </p>
        {transactionState === 'PENDING' && (
          <p className="col-start-1 text-[#E7496C]">
            Por favor verificar si el débito fue realizado en el Banco. Requieres validar esta información, puedes contactarnos a través de {' '} 
            <a href="https://educacionestrella.com/contactanos/" target='_blank' rel="noreferrer">
              https://educacionestrella.com/contactanos/
            </a> 
          </p>
        )}
      </div>
      <Button className='mt-5'>
        <Link to={'/'}>Cerrar ventana</Link>
      </Button>
    </div>
  );
};

export default LandingPayu;
